import { Link } from "@tanstack/react-router";
import { cardMeta } from "../lib/labels";
import type { CatalogItem, SortMode } from "../lib/types";

// One catalog card — a faithful port of cardHtml() from app.js. Links into the
// player route; lab/queued games carry their catalog so detail resolves exactly.
export function GameCard({ item, sort }: { item: CatalogItem; sort: SortMode }) {
  const held = item.playability === "queued";
  const unfinished = item.multiplayer && item.experimental;
  const meta = cardMeta(item, sort);
  const contents = (
    <>
      {item.thumbnail ? (
        <img className="thumb" src={item.thumbnail} alt="" loading="lazy" decoding="async" />
      ) : (
        <span className="thumb thumb-empty" aria-hidden="true" />
      )}
      <span className="card-body">
        <span className="t">{item.title}</span>
        {(meta || item.multiplayer) && (
          <span className="m">
            {item.multiplayer && (
              <>
                <span
                  className="tag-mp"
                  title="Online multiplayer — sign in with a reArcade account"
                  aria-hidden="true"
                >
                  2P
                </span>
                <span className="visually-hidden">multiplayer · </span>
              </>
            )}
            {unfinished && <span className="tag-progress">In progress</span>}
            {meta}
          </span>
        )}
      </span>
    </>
  );

  if (unfinished) {
    return (
      <article
        className="card unfinished"
        aria-disabled="true"
        title={`${item.title} is still in progress and cannot be played yet`}
      >
        {contents}
      </article>
    );
  }

  return (
    <Link
      className={`card${held ? " held" : ""}`}
      to="/game/$id"
      params={{ id: item.id }}
      search={item.catalog !== "games" ? { catalog: item.catalog } : {}}
      title={item.title}
    >
      {contents}
    </Link>
  );
}
